'use client';
const imgixLoader = ({ src, width, quality }) => {
    const url = new URL(src);
    const params = url.searchParams;
    params.set('w', width.toString());
    params.set('q', quality?.toString() || '50');
    return url.href;
};
// breakpoints align with tailwind default screen sizes (https://tailwindcss.com/docs/screens)
const IMAGE_SIZE_PREFIXES = {
    '2xl': '(min-width: 1536px) ',
    xl: '(min-width: 1280px) ',
    lg: '(min-width: 1024px) ',
    md: '(min-width: 768px) ',
    sm: '(min-width: 640px) ',
    dflt: '',
};
const getSizesString = (sizes) => {
    if (!sizes) {
        return '';
    }
    return Object.entries(sizes)
        .map(([size, value]) => `${IMAGE_SIZE_PREFIXES[size]}${convertRem(value)}`)
        .join(', ');
};
const convertRem = (value) => {
    if (value.includes('rem')) {
        const valueAsNum = parseFloat(value);
        if (!isNaN(valueAsNum)) {
            return `${valueAsNum * 16}px`;
        }
    }
    return value;
};
const getImgixImageProps = ({ sizes, src, fit, auto, }) => {
    const srcUrl = new URL(src);
    srcUrl.searchParams.set('fit', fit || 'max');
    srcUrl.searchParams.set('auto', auto || 'format');
    return {
        loader: imgixLoader,
        sizes: getSizesString(sizes),
        src: srcUrl.href,
    };
};

export { getImgixImageProps, getSizesString, imgixLoader };
//# sourceMappingURL=imgix-loader.js.map
